import React from "react";
import { fabricFocus } from "../mock";
import { Link } from "react-router-dom";
import { ArrowRight, Zap, Database, Layers, Radio, Shield, Code2 } from "lucide-react";

const pillarIcons = [Layers, Zap, Database, Radio, Shield, Code2];

const FabricFocus = () => {
  return (
    <section className="py-24 bg-[#0B1B3B] text-white relative overflow-hidden">
      <div className="absolute inset-0 grid-lines-bg opacity-40" />
      <div
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full orb"
        style={{ background: "radial-gradient(closest-side, rgba(30,86,227,0.28), transparent 70%)" }}
      />
      <div
        className="absolute -bottom-24 -left-24 w-[500px] h-[500px] rounded-full orb"
        style={{ background: "radial-gradient(closest-side, rgba(124,166,255,0.18), transparent 70%)" }}
      />

      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#7CA6FF] bg-white/5 border border-white/10 px-3 py-1.5 rounded-full">
              {fabricFocus.eyebrow}
            </span>
            <h2 className="mt-4 text-3xl md:text-[42px] font-bold leading-tight">{fabricFocus.title}</h2>
            <p className="mt-5 text-slate-300 leading-relaxed">{fabricFocus.subtitle}</p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              {fabricFocus.metrics.map((m) => (
                <div key={m.l} className="rounded-xl border border-white/10 bg-white/[0.03] px-5 py-4">
                  <div className="text-3xl font-extrabold">{m.m}</div>
                  <div className="mt-1 text-[11px] uppercase tracking-wider text-slate-400">{m.l}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/case-studies/microsoft-fabric-onelake-optimization" className="btn-primary">
                See a Fabric case study <ArrowRight size={16} />
              </Link>
              <Link to="/fabric-playbook" className="btn-outline">Download Fabric Playbook</Link>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {fabricFocus.pillars.map((p, i) => {
              const Icon = pillarIcons[i % pillarIcons.length];
              return (
                <div
                  key={p.title}
                  className="reveal rounded-2xl border border-white/10 bg-white/[0.03] p-6 hover:bg-white/[0.06] hover:border-white/20 transition-colors"
                >
                  <div className="h-11 w-11 rounded-xl bg-[#1E56E3]/20 text-[#7CA6FF] border border-[#1E56E3]/30 flex items-center justify-center">
                    <Icon size={18} />
                  </div>
                  <h3 className="mt-4 text-lg font-bold text-white">{p.title}</h3>
                  <p className="mt-2 text-[13px] text-slate-300 leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FabricFocus;
